import { X, Info } from 'lucide-react';
import { EmployeeFieldsEditor } from './EmployeeFieldsEditor';

/**
 * Lets an owner customize which employee fields are enabled without
 * leaving the Add/Edit Employee page — opened from the pencil icon there.
 * Saves through the exact same settings endpoint as the full Settings
 * page, so both stay in sync automatically.
 */
export function EmployeeFieldsModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div className="bg-[var(--bg-card)] rounded-[16px] max-w-2xl w-full max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-[var(--border)] sticky top-0 bg-[var(--bg-card)]">
          <h2 className="text-[16px] font-bold text-[var(--text-primary)]">Customize Employee Fields</h2>
          <button type="button" onClick={onClose} className="p-1.5 rounded-[8px] hover:bg-[var(--bg-muted)] text-[var(--text-secondary)]"><X size={16}/></button>
        </div>
        <div className="p-5 space-y-4">
          <div className="flex items-start gap-2 px-4 py-3 rounded-[10px] bg-blue-50 dark:bg-blue-900/20 border border-blue-200 text-[13px] text-blue-700">
            <Info size={14} className="mt-0.5 shrink-0"/>
            <p>Turn fields on or off here — the form below updates as soon as you save.</p>
          </div>
          <EmployeeFieldsEditor compact onSaved={onClose}/>
        </div>
      </div>
    </div>
  );
}
